import { useEffect, useRef } from 'react';

interface JsonLdProps {
  data: Record<string, unknown> | Record<string, unknown>[];
}

// Injects JSON-LD <script> tags into <head> and removes them on unmount.
// Using useEffect instead of react-helmet-async because Helmet does not
// reliably remove <script> tags when navigating between routes in a SPA —
// causing schemas from previous pages to accumulate in the DOM.
export const JsonLd = ({ data }: JsonLdProps) => {
  const scriptsRef = useRef<HTMLScriptElement[]>([]);

  useEffect(() => {
    const payload = Array.isArray(data) ? data : [data];

    payload.forEach(schema => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
      scriptsRef.current.push(script);
    });

    return () => {
      scriptsRef.current.forEach(s => s.parentNode?.removeChild(s));
      scriptsRef.current = [];
    };
  }, [JSON.stringify(data)]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
};
